import { render, staticRenderFns } from "./PageVmLayout.vue?vue&type=template&id=ea08b46c&"
import script from "./PageVmLayout.vue?vue&type=script&lang=js&"
export * from "./PageVmLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports